import { render, staticRenderFns } from "./MisVisitas.vue?vue&type=template&id=5ed9fb84&"
import script from "./MisVisitas.vue?vue&type=script&lang=ts&"
export * from "./MisVisitas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports